<div class="plant-wrap">
    <div class="plant-parallax" #plantParallax></div>
    <div class="container">
        <div class="row">
            <div class="col-12 col-md my-md-3 d-flex align-items-center justify-content-center text-center">
                <h2 class="mb-0">My {{(plants | plant: 'active')?.length}} plants</h2>
            </div>
            <div class="col col-md-auto my-3 d-flex align-items-center justify-content-center">
                <button class="btn btn-browny mx-2" (click)="toggleSortOrder()">{{sortOrder}}</button>
                <select class="dropdown btn btn-browny" (change)="onSortValueChange($event.target.value)">
                    <option value="lastWater" [selected]="sortValue === 'lastWater'">Sort By: Last Water</option>
                    <option value="name" [selected]="sortValue === 'name'">Sort By: Name</option>
                    <option value="birthdate" [selected]="sortValue === 'birthdate'">Sort By: BirthDate</option>
                </select>
            </div>
            <div class="col col-md-auto my-3 d-flex align-items-center justify-content-center">
                <button *ngIf="user" class="btn btn-browny ml-2" data-toggle="modal" data-target="#plantAdd">+</button>
                <button *ngIf="user" class="btn water-drop m-0 mr-md-2" data-toggle="modal" data-target="#massWater"></button>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-6 col-md-auto" *ngFor="let plant of plants | plant: 'active': sortValue: sortOrder ">
                <div class="plant-box"
                    (click)="setEdit(plant)"
                    data-toggle="modal"
                    data-target="#plantEdit">
                    <img alt="plant" [src]="plant.imgThumb || plant.img.url" loading="lazy" class="product-image">
                    <div class="bottom-bar text-left ">
                        <h6 class="mb-0 mt-1">{{plant.name}}</h6>
                        <div class="watered-icon" [ngClass]="getWaterIcon(plant.lastWater, plant.waterFrequency)"></div>
                        <div class="last">{{getLast(plant.lastWater)}}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row my-5">
            <div class="col">
                <h3 class="text-center">My past {{(plants | plant: 'inactive')?.length}} plants</h3>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-6 col-md-auto" *ngFor="let plant of plants | plant: 'inactive' ">
                <div class="plant-box"
                    (click)="setEdit(plant)"
                    data-toggle="modal"
                    data-target="#plantEdit">
                    <img alt="plant" [src]="plant.imgThumb || plant.img.url" loading="lazy" class="product-image">
                    <div class="bottom-bar text-left ">
                        <h6 class="mb-0 mt-1">{{plant.name}}</h6>
                        <div class="watered-icon" [ngClass]="getWaterIcon(plant.lastWater, plant.waterFrequency)"></div>
                        <div class="last">{{getLast(plant.lastWater)}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Add Modal -->
<div class="modal fade" id="plantAdd" tabindex="-1" role="dialog" aria-labelledby="plantAddLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content color5">
            <button id="closeButton" type="button" class="color5 custom-close" data-dismiss="modal" aria-label="Close">
                <span data-dismiss="modal" aria-label="Close">&times;</span>
            </button>
            <div class="modal-body d-flex ">
                <h3>Add Plant</h3>
                <input type="file" (change)="prep($event)" accept=".png,.jpeg,.jpg" />
                <img alt="plant" *ngIf="this.preview" height="80" width="80" src="{{this.preview}}" class="product-image">
                <input [(ngModel)]="name" placeholder="Name"/>
                <textarea [(ngModel)]="care" placeholder="Care instructions"></textarea>
                <textarea [(ngModel)]="wateringNotes" placeholder="Watering instructions"></textarea>
                <div class="d-flex">
                    <p class="d-inline-block mr-2">Water frequency</p>
                    <input class="d-inline-block" style="width: 50px;" type="number" [(ngModel)]="waterFrequency">
                </div>

                <div class="d-flex justify-content-around">
                    <div (click)="sunAmmount = sunAmmountType.Full">
                        <div class="sun full-sun" [ngClass]="{activeSun: sunAmmount == sunAmmountType.Full}"></div>
                        <p>Full Sun</p>
                    </div>
                    <div (click)="sunAmmount = sunAmmountType.PartialSun">
                        <div class="sun part-sun" [ngClass]="{activeSun: sunAmmount == sunAmmountType.PartialSun}"></div>
                        <p>Partial Sun</p>
                    </div>
                    <div (click)="sunAmmount = sunAmmountType.PartialShade">
                        <div class="sun part-shade" [ngClass]="{activeSun: sunAmmount == sunAmmountType.PartialShade}"></div>
                        <p>Partial Shade</p>
                    </div>
                    <div (click)="sunAmmount = sunAmmountType.FullShade">
                        <div class="sun full-shade" [ngClass]="{activeSun: sunAmmount == sunAmmountType.FullShade}"></div>
                        <p>Full Shade</p>
                    </div>
                </div>
                <button *ngIf="user" (click)="addPlant()">Save Plant</button>
            </div>
        </div>
    </div>
</div>

<!-- Edit Modal -->
<div class="modal fade" id="plantEdit" tabindex="-1" role="dialog" aria-labelledby="plantEditLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content color5">
            <button id="closeEdit" type="button" class="color5 custom-close" data-dismiss="modal" aria-label="Close">
                <span data-dismiss="modal" aria-label="Close">&times;</span>
            </button>
            <div class="modal-body d-flex ">
                <div *ngIf="user" class="d-flex">
                    <h5 class="mr-2">Active:</h5>
                    <mat-slide-toggle [(ngModel)]="selectedPlant.active"></mat-slide-toggle>
                </div>
                <h3 class="text-center">{{selectedPlant.name}}</h3>
                <img alt="plant" *ngIf="selectedPlant.img && !selectedPlant.imgLog" src="{{selectedPlant.img}}" class="product-image" (click)="updateImage =!updateImage">
                <ngb-carousel *ngIf="selectedPlant.imgLog" class="text-center" [showNavigationIndicators]="false">
                    <ng-template class="text-center" ngbSlide *ngFor="let img of selectedPlant.imgLog.slice().reverse()">
                        <img class="modal-plant-img" [src]="img.url" alt="plant"  (click)="updateImage =!updateImage">
                    </ng-template>
                </ngb-carousel>

                <div *ngIf="user">
                    <div *ngIf="updateImage">
                        <input type="file" (change)="prep($event)" accept=".png,.jpeg,.jpg" />
                        <img alt="plant" *ngIf="this.preview" height="80" width="80" src="{{this.preview}}" class="product-image">
                    </div>
                </div>
                <div class="row my-3">
                    <div class="col-4 text-center">
                        <div class="water-drop" [ngClass]="{'uploading': uploading}" (click)="waterPlant()"></div>
                        <div (click)="waterPlant()">Track Watering</div>
                    </div>
                    <div class="col-4 text-center">
                        <div class="watered-icon" [ngClass]="getWaterIcon(selectedPlant.lastWater, selectedPlant.waterFrequency)" (click)="showWaterLog = !showWaterLog; showSunAmmount = false"></div>
                        <div class="last">Watered {{getLast(selectedPlant.lastWater)}}</div>
                    </div>
                    <div class="col-4 text-center">
                        <div class="sun" [ngClass]="getSunIcon(selectedPlant.sunAmmount)" (click)="showSunAmmount = !showSunAmmount; showWaterLog = false"></div>
                        <div class="last">{{selectedPlant.sunAmmount}}</div>
                    </div>
                </div>
                <div class="d-flex justify-content-around" *ngIf="showSunAmmount">
                    <div (click)="selectedPlant.sunAmmount = sunAmmountType.Full">
                        <div class="sun full-sun"></div>
                        <p>Full Sun</p>
                    </div>
                    <div (click)="selectedPlant.sunAmmount = sunAmmountType.PartialSun">
                        <div class="sun part-sun"></div>
                        <p>Partial Sun</p>
                    </div>
                    <div (click)="selectedPlant.sunAmmount = sunAmmountType.PartialShade">
                        <div class="sun part-shade"></div>
                        <p>Partial Shade</p>
                    </div>
                    <div (click)="selectedPlant.sunAmmount = sunAmmountType.FullShade">
                        <div class="sun full-shade"></div>
                        <p>Full Shade</p>
                    </div>
                </div>
                <div *ngIf="showWaterLog">
                    <div class="d-flex justify-content-between">
                        <h5>Water Log:</h5>
                        <div>
                            <p class="d-inline-block mr-2">Water frequency</p>
                            <input class="d-inline-block" style="width: 50px;" type="number" [(ngModel)]="selectedPlant.waterFrequency">
                        </div>
                    </div>
                    <p *ngFor="let log of selectedPlant.waterLog" class="my-0 mr-2 d-inline-block">{{log.date}},</p>
                    <h5 class="mt-2">Watering notes:</h5>
                    <textarea class="plant-care" placeholder="Watering Care" [(ngModel)]="selectedPlant.wateringNotes"></textarea>
                </div>
                <h5 class="mt-2">Plant care notes:</h5>
                <textarea *ngIf="user" [(ngModel)]="selectedPlant.care" placeholder="Care instructions" class="plant-care"></textarea>
                <p *ngIf="!user">{{selectedPlant.care}}</p>
                <!-- <button class="btn water-btn" (click)="waterPlant()">Water Plant</button> -->
                <button *ngIf="user" class="btn btn-browny mt-4" (click)="editPlant()">Save Edit</button>
            </div>
        </div>
    </div>
</div>



<!-- Mass Water Modal -->

<div class="modal fade" id="massWater" tabindex="-1" role="dialog" aria-labelledby="massWaterLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content color5">
            <button id="closeButton" type="button" class="color5 custom-close" data-dismiss="modal" aria-label="Close">
                <span data-dismiss="modal" aria-label="Close">&times;</span>
            </button>
            <div class="modal-body">
                <h3>Bulk Water</h3>
                <div class="row">
                    <div class="col-6 checkbox-wrap my-1" *ngFor="let plant of plants | plant: 'active': sortValue: sortOrder">
                        <label for="{{plant.key}}" class="mr-3">{{plant.name}}</label>
                        <input type="checkbox" name="" id="{{plant.key}}" [checked]="selectedPlants.includes(plant.key)" (change)="togglePlantSelection(plant.key)">
                    </div>
                </div>
                <button class="btn cancel-btn" data-dismiss="modal" aria-label="Close">Cancel</button>
                <button *ngIf="user" class="btn btn-browny float-right" (click)="massWater()">Save</button>
            </div>
        </div>
    </div>
</div>
